import { c as _c } from "react/compiler-runtime";
import { cx } from 'class-variance-authority';
import type { HTMLAttributes, ReactNode } from 'react';
export type TagProps = {
  children: ReactNode;
} & HTMLAttributes<HTMLSpanElement>;
const Tag = t0 => {
  const $ = _c(10);
  let children;
  let className;
  let props;
  if ($[0] !== t0) {
    ({
      children,
      className,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = children;
    $[2] = className;
    $[3] = props;
  } else {
    children = $[1];
    className = $[2];
    props = $[3];
  }
  let t1;
  if ($[4] !== className) {
    t1 = cx(className, "inline-flex items-center h-6", "text-caption-1 text-neutral whitespace-nowrap", "px-2 py-1", "border border-solid border-primary", "rounded-full");
    $[4] = className;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  let t2;
  if ($[6] !== children || $[7] !== props || $[8] !== t1) {
    t2 = <span className={t1} {...props}>{children}</span>;
    $[6] = children;
    $[7] = props;
    $[8] = t1;
    $[9] = t2;
  } else {
    t2 = $[9];
  }
  return t2;
};
export default Tag;